let state = {
    provinces: '', // 省市信息
    provincesIdMap: {}, // 省id map
    citysIdMap: {}, // 市id map
    grades: '', // 年级信息
};
export default state;


// WEBPACK FOOTER //
// ./src/vuex/modules/provincialGrade/state.js